import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/outline';
import { Fragment } from 'react';
import { useHistory } from 'react-router';
import { useQuery } from 'utils/useQuery';

export const CohortTimeAnchorSelect = () => {
  const options = ['calendar', 'relative'];

  const query = useQuery();
  const lapseRangeType = (query.get('lapse_range_type') ?? 'calendar') as
    | 'calendar'
    | 'relative';

  const history = useHistory();

  const handleChange = (e: 'calendar' | 'relative') => {
    query.set('lapse_range_type', e);

    history.push({ search: query.toString() });
  };

  return (
    <Listbox value={lapseRangeType} onChange={handleChange}>
      <div className="relative">
        <Listbox.Button className="relative w-24 py-2 pr-8 text-left cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 ">
          <span className="font-bold text-segments-link capitalize text-base">
            {lapseRangeType}
          </span>

          <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none">
            <ChevronDownIcon
              className="w-5 h-5 text-gray-600"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-20 w-[139px] -right-2 py-1 overflow-auto text-base bg-white rounded-[24px] shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {options.map((option, index) => (
              <Listbox.Option
                key={index}
                className={({ active }) =>
                  `${active ? ' bg-gray-100' : 'text-gray-900'}
                          cursor-default select-none relative py-2 pl-11 text-base`
                }
                value={option}
              >
                {({ selected, active }) => (
                  <>
                    <span
                      className={`${
                        selected ? 'font-medium' : 'font-normal'
                      } block capitalize`}
                    >
                      {option}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-4 ">
                        <CheckIcon className="w-5 h-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};
